import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import OneQuestionPerday from '../entities/article'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface OneQuestionPerdayState extends ListState<OneQuestionPerday> {
    editOneQuestionPerday: OneQuestionPerday;
    cascaders: any;
    topicCascaders: any;
}
class OneQuestionPerdayModule extends ListModule<OneQuestionPerdayState, any, OneQuestionPerday>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OneQuestionPerday>(),
        loading: false,
        editOneQuestionPerday: new OneQuestionPerday(),
        cascaders: new Array<Cascader>(),
        topicCascaders: new Array<Cascader>()
    }
    actions = {
        async getAll(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/OneQuestionPerday/GetAll', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<OneQuestionPerday>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllMyselfAndChildren(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/OneQuestionPerday/GetAllMyselfAndChildren', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<OneQuestionPerday>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },async getAllModerated(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/OneQuestionPerday/GetAllModerated', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<OneQuestionPerday>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            await Ajax.post('/api/services/app/OneQuestionPerday/Create', payload.data);
        },
        async update(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            await Ajax.put('/api/services/app/OneQuestionPerday/Update', payload.data);
        },
        async delete(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            await Ajax.delete('/api/services/app/OneQuestionPerday/Delete?Id=' + payload.data.id);
        },
        async auditedOneQuestionPerday(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/OneQuestionPerday/AuditedOneQuestionPerday', payload.data);
            context.state.loading = false;
        },
        async get(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/OneQuestionPerday/Get?Id=' + payload.id);
            return reponse.data.result as OneQuestionPerday;
        },
        async getCascader(context: ActionContext<OneQuestionPerdayState, any>, payload: any) {            
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders =  reponse.data.result as Array<Cascader>;           
            context.state.loading = false;
        }
    };
    mutations = {
        setCurrentPage(state: OneQuestionPerdayState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OneQuestionPerdayState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: OneQuestionPerdayState, oneQuestionPerday: OneQuestionPerday) {
            state.editOneQuestionPerday = oneQuestionPerday;
        }
    }
}
const oneQuestionPerdayModule = new OneQuestionPerdayModule();
export default oneQuestionPerdayModule;